<template>
  <section>
    <h2 v-if="onBoarding.substep != 0">Step 1 / 3</h2>
    <h3 v-if="onBoarding.substep != 0" class="card-title text-primary">
      {{ $t("lang.onBoarding.describe_your_services") }}
    </h3>
    <Modal :name="'confirm'" v-if="!loading">
      <div class="p-4 text-center">
        <h3 class="card-title text-primary mb-2">
          {{ $t("lang.onBoarding.confirm_order") }}
        </h3>
        <h5 class="">
          {{ $t("lang.onBoarding.pay_only_for_performance") }}
        </h5>
        <div class="row justify-content-center border py-4">
          <div class="col-lg-4">
            <VideoToolToy
              :url="'https://player.vimeo.com/video/748707061?h=a253017bbf'"
            />
          </div>
          <div class="col-lg-8">
            <CreditCardForm
              ref="creditCardForm"
              :confirmPayment="false"
              :showSaveButton="true"
              :showPrincipal="false"
              :profileData="true"
              @refreshPaymentMethods="refreshPaymentMethods"
            />
          </div>
        </div>
        <div class="row mt-5 justify-content-center">
          <div class="col-md-4">
            <span class="img-fluid">
              <img src="@/assets/images/oliver-b.png" alt />
            </span>
            <p class="text-secondary mt-3">
              {{ $t("lang.onBoarding.set_up_free") }}
            </p>
          </div>
          <div class="col-md-4">
            <span class="img-fluid">
              <img src="@/assets/images/oliver-a.png" alt />
            </span>
            <p class="text-secondary mt-3">
              {{ $t("lang.onBoarding.without_commitment") }}
            </p>
          </div>
          <div class="col-md-4">
            <span class="img-fluid">
              <img src="@/assets/images/oliver-b.png" alt />
            </span>
            <p class="text-secondary mt-3">
              {{ $t("lang.onBoarding.ro_results_no_invoice") }}
            </p>
          </div>
        </div>
      </div>
    </Modal>
    <div v-if="onBoarding.substep == 0">
      <h3 class="card-title text-primary">
        {{ $t("lang.onBoarding.first_order") }}
      </h3>
      <h6>{{ $t("lang.onBoarding.how_does_it_works") }}</h6>
      <div class="embed-responsive embed-responsive-16by9 mt-3 mb-3">
        <VideoToolToy
          :url="'https://player.gotolstoy.com/kcjsnqihuoogs?host'"
        />

        <!-- <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/CrMAy18VRg4" allowfullscreen></iframe> -->
      </div>
      <div class="text-center mt-4">
        <button
          class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-primary
            mx-1
            px-4
          "
          type="button"
          @click="start()"
        >
          {{ $t("lang.button.start") }}
        </button>
      </div>
    </div>

    <div v-if="onBoarding.substep == 1">
      <div class="card-body text-center">
        <p>
          {{
            $t(
              "lang.onBoarding.step1_1_hint",
              this.$store.state.onboarding.lang
            )
          }}
        </p>
        <h5 class="mt-5">
          {{
            $t(
              "lang.onBoarding.step1_2_question",
              this.$store.state.onboarding.lang
            )
          }}
        </h5>

        <div class="row justify-content-center">
          <div class="col-xs-10 mt-2">
            <select v-model="onBoarding.step3.tag_id" class="form-control"
            @change="changeTagId">
              <option
                v-for="(tag, i) in tag_2"
                :key="`Tag${i}`"
                :value="tag.id"
                class="optionSelect"
              >
                {{ tag.name }}
              </option>
            </select>
          </div>
        </div>
        <h5 class="mt-5">
          {{
            $t(
              "lang.onBoarding.step1_1_question",
              this.$store.state.onboarding.lang
            )
          }}
        </h5>
        <div class="row justify-content-center">
          <div class="col-xs-10">
            <input
              class="
                form-control form-control-lg
                text-center text-primary
                my-3
                border-0
              "
              placeholder="_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _"
              maxlength="40"
              type="text"
              :value="onBoarding.productName"
              @input="changeProductName"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="onBoarding.substep == 2">
      <div class="card-body text-center">
        <h4 class="my-5">
          {{
            $t(
              "lang.onBoarding.step1_2_beatiful_name",
              this.$store.state.onboarding.lang
            )
          }}
        </h4>
        <h5 class="mb-3">
          {{
            $t(
              "lang.onBoarding.step1_2_we_are_oliverlist",
              this.$store.state.onboarding.lang
            )
          }}
          <b class="text-primary font-weight-bold">{{
            $t("lang.onBoarding.oliverlist", this.$store.state.onboarding.lang)
          }}</b>
        </h5>
      </div>
    </div>

    <div v-for="item in substepsdata">
      <SubstepTextCard
        v-if="item.substep == onBoarding.substep"
        :key="item.key"
        :value="item.value"
        :value2="item.value2"
        :value3="item.value3"
        :prePend="item.prePend"
        :subStep="item.substep"
        :index="item.index"
        :type="item.type"
      />
    </div>

    <div v-if="onBoarding.substep == 13">
      <div class="card-body text-center">
        <h3 class="pt-2 pb-2 mt-5">
          {{
            $t("lang.onBoarding.excellent", this.$store.state.onboarding.lang)
          }}
        </h3>
        <h6 class="text-primary">
          {{
            $t(
              "lang.onBoarding.lets_move_on",
              this.$store.state.onboarding.lang
            )
          }}
        </h6>
      </div>
    </div>

    <div v-if="onBoarding.substep == 14" class="mt-4">
      <modal name="step15" :resizable="true" height="auto" width="90%">
        <div class="p-4 text-left">
          <h3 class="card-title text-primary mb-2">
            {{
              $t(
                "lang.onBoarding.mails_modal_title",
                this.$store.state.onboarding.lang
              )
            }}
          </h3>
          <p class="text-secondary mb-3">
            {{
              $t(
                "lang.onBoarding.mails_modal_description",
                this.$store.state.onboarding.lang
              )
            }}
          </p>

          <div class="row">
            <div class="col-md-5">
              <Step1Summary />
            </div>
            <div class="col-md-7">
              <MailsModal />
            </div>
          </div>
          <div class="row justify-content-center">
            <button
              class="
                btn btn-secondary
                large
                cursor-pointer
                font-weight-bolder
                mt-4
                mr-2
              "
              type="button"
              @click="closeModal(15)"
            >
              {{ $t("lang.button.back") }}
            </button>
          </div>
        </div>
      </modal>
      <Step1Summary />
    </div>

    <div class="text-center" v-if="onBoarding.substep == 13">
      <a class="text-primary mt-5" type="button" @click="summary"
        ><i class="icon-arrow-right"></i>
        {{
          $t(
            "lang.onBoarding.i_want_a_summary",
            this.$store.state.onboarding.lang
          )
        }}
      </a>
    </div>

    <div class="text-center" v-if="onBoarding.substep == 14">
      <a class="text-primary mt-5" type="button" @click="showModal(15)"
        ><i class="icon-arrow-right"></i>
        {{
          $t(
            "lang.onBoarding.see_email_examples_generated",
            this.$store.state.onboarding.lang
          )
        }}
      </a>
    </div>

    <!-- MODAL Targets -->
    <Modal
      :name="'language'"
      :size="'30'"
      v-if="!loading"
      :close="false"
      v-bind:close-on-backdrop="false"
      v-bind:close-on-esc="false"
    >
      <div class="p-4 mt-4 text-center">
        <h4>{{ $t("lang.onBoarding.step1_0_modal_title") }}</h4>
        <div class="row justify-content-center">
          <div class="col-xs-5">
            <input
              class="
                form-control form-control-lg
                text-primary text-center
                border-0
              "
              placeholder="_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ "
              type="text"
              maxlength="40"
              :value="onBoarding.orderName"
              @input="changeOrderName"
            />
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="form-group row justify-content-center display-inline mr-4">
          <label
            for="staticEmail"
            class="col-md-3 col-form-label font-weight-bold"
            >{{ $t("lang.label.language") }}:</label
          >
          <div class="col-md-4">
            <select
              v-model="onBoarding.lang"
              @change="changeLanguage"
              class="langSelect form-control"
            >
              <option
                v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                :value="lang.type"
                class="optionSelect"
              >
                {{ lang.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mb-4">
        <button
          class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-outline-dark
            mx-1
            px-4
          "
          @click="
            $modal.hide('language');
            goBack();
          "
        >
          {{ $t("lang.button.back") }}
        </button>
        <button
          class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-primary
            mx-1
            px-4
            ml-5
          "
          @click="nextSubStep"
          :disabled="answerNull()"
        >
          {{ $t("lang.button.next") }}
        </button>
      </div>
    </Modal>
  </section>
</template>

<script>
import MailsModal from "@/components/Onboarding/MailsModal.vue";
import Modal from "@/components/Common/Modal.vue";
import Step1Summary from "@/components/Onboarding/MultiSteps/Step1Summary.vue";
import SubstepTextCard from "@/components/Onboarding/MultiSteps/SubstepTextCard.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      onBoarding: (state) => state.onboarding,
      loading: (state) => state.onboarding.loading,
      user: (state) => state.authentication.user,
      subStep: (state) => state.onboarding.substep,
      tag_2: (state) => state.optionsList.all["tag_2"].data,
    }),
  },
  props: {
    addOrder: Boolean,
  },
  data() {
    return {
      substepsdata: [],
      loadingCreditCard: false,
      langs: [
        {
          type: "es",
          label: this.$t("lang.onBoarding.lang.spanish"),
        },
        {
          type: "en",
          label: this.$t("lang.onBoarding.lang.english"),
        },
        {
          type: "fr",
          label: this.$t("lang.onBoarding.lang.french"),
        },
      ],
    };
  },

  components: {
    MailsModal,
    Step1Summary,
    SubstepTextCard,
    VideoToolToy,
    CreditCardForm,
    Modal,
  },
  mounted() {
    if (!this.onBoarding.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.$store.dispatch("optionsList/getAvailableTokens");

    this.substepsdata = [
      {
        substep: 3,
        key: 7,
        value: "what_we_created",
        value2: undefined,
        value3: undefined,
        tip: true,
        index: 1,
        type: 1,
      },
      {
        substep: 4,
        value: "we_propose",
        value2: undefined,
        value3: undefined,
        index: 2,
        type: 1,
        key: 1,
      },
      {
        substep: 5,
        key: 2,
        value: "we_are_convinced",
        value2: undefined,
        value3: undefined,
        subStep: 4,
        index: 3,
        type: 2,
      },
      {
        substep: 6,
        key: 3,
        value: "in_few_words",
        value2: undefined,
        value3: undefined,
        index: 4,
        type: 2,
      },
      {
        substep: 7,
        key: 4,
        value: "we_wanted_to_exchange_about",
        value2: undefined,
        value3: undefined,
        index: 5,
        type: 2,
      },
      {
        substep: 8,
        key: 5,
        value: "the_idea_is_simple",
        value2: undefined,
        value3: undefined,
        index: 6,
        type: 2,
      },
      {
        substep: 9,
        key: 6,
        value: "we_were_wondering_how",
        value2: undefined,
        value3: undefined,
        index: 7,
        type: 2,
      },
      {
        substep: 10,
        value: "prospect_area",
        value2: undefined,
        value3: undefined,
        index: 8,
        type: 3,
        key: 8,
      },
      {
        substep: 11,
        key: 9,
        value: "argument_1",
        value2: "argument_2",
        value3: "argument_3",
        index: 9,
        type: 5,
      },
      {
        substep: 12,
        key: 10,
        value: "ref_1",
        value2: "ref_2",
        value3: "ref_3",
        index: 10,
        type: 4,
      },
    ];

    if (this.onBoarding.substep == 1 && this.onBoarding.step == 1) {
      this.$modal.show("language");
    }

    if (
      this.onBoarding.substep == 0 &&
      this.onBoarding.step == 1 &&
      this.onBoarding.orderId == 0 &&
      this.user.agency_signed == "0" &&
      !this.addOrder &&
      !this.simplify
    ) {
      this.$modal.show("confirm");
    }

    this.substepsdata = [
      {
        substep: 3,
        key: 7,
        value: "what_we_created",
        value2: undefined,
        value3: undefined,
        tip: true,
        index: 1,
        type: 1,
      },
      {
        substep: 4,
        value: "we_propose",
        value2: undefined,
        value3: undefined,
        index: 2,
        type: 1,
        key: 1,
      },
      {
        substep: 5,
        key: 2,
        value: "we_are_convinced",
        value2: undefined,
        value3: undefined,
        subStep: 4,
        index: 3,
        type: 2,
      },
      {
        substep: 6,
        key: 3,
        value: "in_few_words",
        value2: undefined,
        value3: undefined,
        index: 4,
        type: 2,
      },
      {
        substep: 7,
        key: 4,
        value: "we_wanted_to_exchange_about",
        value2: undefined,
        value3: undefined,
        index: 5,
        type: 2,
      },
      {
        substep: 8,
        key: 5,
        value: "the_idea_is_simple",
        value2: undefined,
        value3: undefined,
        index: 6,
        type: 2,
      },
      {
        substep: 9,
        key: 6,
        value: "we_were_wondering_how",
        value2: undefined,
        value3: undefined,
        index: 7,
        type: 2,
      },
      {
        substep: 10,
        value: "prospect_area",
        value2: undefined,
        value3: undefined,
        index: 8,
        type: 3,
        key: 8,
      },
      {
        substep: 11,
        key: 9,
        value: "argument_1",
        value2: "argument_2",
        value3: "argument_3",
        index: 9,
        type: 5,
      },
      {
        substep: 12,
        key: 10,
        value: "ref_1",
        value2: "ref_2",
        value3: "ref_3",
        index: 10,
        type: 4,
      },
    ];
    this.validateSubStep();
  },
  watch: {
    subStep() {
      this.validateSubStep();
    },
  },
  methods: {
    refreshPaymentMethods() {
      location.reload();
    },
    start() {
      if (
        this.onBoarding.substep == 0 &&
        this.onBoarding.step == 1 &&
        this.onBoarding.orderId == 0 &&
        this.user.agency_signed == 0 &&
        !this.addOrder &&
        !this.simplify
      ) {
        this.$modal.show("confirm");
        return;
      }

      //this.setSubStep(1);
      this.setStep(3);
      this.$modal.show("language");
    },
    goBack() {
      if (this.addOrder) {
        this.$router.push("/orders");
      } else {
        this.back();
      }
    },
    validateSubStep() {
      if (this.onBoarding.substep == 1 && this.onBoarding.step == 1) {
        this.$modal.show("language");
      }
    },
    summary() {
      let subStep = this.onBoarding.substep + 1;
      this.setSubStep(subStep);
    },
    nextSubStep() {
      this.$modal.hide("language");
    },
    answerNull(substep) {
      return !this.onBoarding.orderName;
    },
    changeLanguage() {
      let language_id;
      if (this.onBoarding.lang == "fr") {
        language_id = 1;
      } else {
        if (this.onBoarding.lang == "en") {
          language_id = 2;
        } else {
          language_id = 3;
        }
      }
      this.setLanguageId(language_id);
    },

    showModal(subStep) {
      this.$modal.show("step" + subStep);
    },
    closeModal(step) {
      this.$modal.hide("step" + step);
      this.request = false;
    },
    ...mapActions("onboarding", {
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      updateOrderName: "updateOrderName",
      updateProductName: "updateProductName",
      updateTagId: "updateTagId",
      setLanguageId: "setLanguageId",
      saveOrder: "save",
      back: "back",
      next: "next",
    }),

    changeOrderName(e) {
      this.updateOrderName(e.target.value);
    },
    changeProductName(e) {
      this.updateProductName(e.target.value);
    },
    changeTagId(e) {
      this.updateTagId(e.target.value);
    },
  },
};
</script>
<style scoped>
.langSelect {
  border: 0.1px lightgray solid;
  background: transparent;
  outline: 0px;
}
</style>